import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";
import { useEffect, useState } from "react";
import ToLogin from "../../../components/misc/Redirect/ToLogin";
import { cambiarContrasenaApi } from "../services/password.service";
import { getHeader } from "../../shared/services/header.service";
import { apiLogout } from "../../shared/services/logout.service";
import useValidatePassword from "./useValidatePassword";


const useInitialState = () => {
    const [state, setState] = useState<any>({});
    const [usuario, setUsuario] = useState<any>({})
    const [loadingFetch, setLoadingFetch] = useState(false);

    useEffect(() => {
        obtenerUsuario()
    }, []);

    const obtenerUsuario = async () => {
        const {data,status} = await getHeader()
        setUsuario(data);
        console.log(data)
    }

    const onChangeContraseniaActual = (e: any) => {
        setState({ ...state, contraseniaActual: e })
    }
    const onChangeNuevaContrasenia = (e: any) => {
        setState({ ...state, nuevaContrasenia: e })
    }
    const onChangeRepitaNuevaContrasenia = (e: any) => {
        setState({ ...state, repitaNuevaContrasenia: e })
    }

    const validarYCambiarPassword = () => {

        const validated: {status: boolean, msg: string} 
            = useValidatePassword({oriPsw: state?.contraseniaActual,newPsw: state?.nuevaContrasenia, repPsw: state?.repitaNuevaContrasenia});
        if(!validated.status){
            showToast('error', 'Error', validated.msg);
            return false;
        } 

        return CambiarPassword();
    }


    const CambiarPassword = async () => {
        setLoadingFetch(true);
        var result = await cambiarContrasenaApi(usuario.login, state.contraseniaActual, state.nuevaContrasenia);
        setLoadingFetch(false);
        if (result.status === 200 ) {
            onLogout();
            return true;
        }
        else {
            showToast('error', 'Error', 'Hubo un error, por favor intente de nuevo');
            return false;
        };
    }

    async function onLogout() {
        setLoadingFetch(true);
        const {data,status} = await apiLogout()
        if(status === 200){
            setState({
                ...state,
                isRedirect: true, url: data.nologin
            });
        }
        setLoadingFetch(false)
        
    }

    const toast = React.useRef<any>(null);

    const showToast = (severity: string, message?: string, content?: string) => {
        toast.current.show({ severity: severity, summary: message, detail: content, life: 5000 });
    }

    const handleLoading = () => {
        if (loadingFetch) {
            return (
                <div className="loading">
                    <ProgressSpinner className="spinner" />
                </div>
            );
        }
    }

    const redireccionar = () => {
        if (state.isRedirect) {
            return (
            <ToLogin url={state.url} titulo="Contraseña cambiada"
                mensaje="Contraseña cambiada correctamente. En unos segundos será redirigido a la pantalla de Login." />
                )
        }
    }


    return {
        state,
        usuario,
        toast,
        setState,
        validarYCambiarPassword,
        onChangeContraseniaActual,
        onChangeNuevaContrasenia,
        onChangeRepitaNuevaContrasenia,
        handleLoading,
        redireccionar
    }
}

export default useInitialState